import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

type ErrorType = string | string[] | Record<string, unknown> | unknown;

interface ErrorDisplayProps {
  error: ErrorType;
  touched?: boolean;
}

export function ErrorDisplay({ error, touched = true }: ErrorDisplayProps) {
  if (!error || !touched) {
    return null;
  }

  // Se o erro é uma string, renderiza diretamente
  if (typeof error === 'string') {
    return (
      <Typography
        variant="metadata-sm-regular"
        color="default"
        className="text-red-600 flex items-center gap-1">
        <span className="text-red-500">•</span>
        {error}
      </Typography>
    );
  }

  // Se o erro é um array, renderiza cada item
  if (Array.isArray(error)) {
    return (
      <div className="space-y-1">
        {error.map((err, index) => (
          <ErrorDisplay key={index} error={err} touched={touched} />
        ))}
      </div>
    );
  }

  // Se o erro é um objeto, renderiza cada propriedade
  if (typeof error === 'object' && error !== null) {
    return (
      <div className="space-y-1">
        {Object.entries(error).map(([key, value]) => (
          <div key={key}>
            <ErrorDisplay error={value} touched={touched} />
          </div>
        ))}
      </div>
    );
  }

  // Fallback: converte para string
  return (
    <Typography
      variant="metadata-sm-regular"
      color="default"
      className="text-red-600 flex items-center gap-1">
      <span className="text-red-500">•</span>
      {String(error)}
    </Typography>
  );
}
